import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as AwardLink } from "assets/images/svgs/award-link.svg";
import { ReactComponent as SecurityUser } from "assets/images/svgs/rsvp/24-support.svg";
import { ReactComponent as EditProfile } from "assets/images/svgs/rsvp/edit-2.svg";
import { ReactComponent as MyExperiences } from "assets/images/svgs/rsvp/favorite-chart.svg";
import { ReactComponent as Setting } from "assets/images/svgs/rsvp/setting-4.svg";
import { ReactComponent as Badges } from "assets/images/svgs/rsvp/verify.svg";
import { ReactComponent as Logout } from "assets/images/svgs/rsvp/logout.svg";
import CustomerSupport from "../CustomerSupport";
import useStore from "hooks/useStore";
import { CommunityIcon } from "assets/images/svgs";

interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

const RsvpNavbarDrawer: React.FC<DrawerProps> = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const { getUserProfilePic, getUserFullName } = useStore();
  const userProfilePic = getUserProfilePic();
  const userFullName = getUserFullName();
  const [showSupportDrawer, setShowSupportDrawer] = useState(false);
  const handleNavigation = (item: any) => {
    if (item.label === "Logout") {
      localStorage.clear();
      onClose();
      navigate(item.link);
      return;
    }

    if (item.label === "Customer Support") {
      // Open the Customer Support modal
      setShowSupportDrawer(true);

      return;
    }

    onClose();
    navigate(item.link);
  };

  return (
    <div
      className={`fixed inset-0 z-50 bg-black bg-opacity-30 transition-opacity duration-300 ${
        isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
      onClick={onClose}
    >
      <div
        className={`fixed top-0 right-0 h-full w-4/5 sm:w-1/2 md:w-1/3 lg:w-[480px] overflow-y-auto bg-white p-4 md:p-6 lg:p-10 shadow-lg transition-transform duration-300 ease-in-out transform ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-2xl text-gray-600 hover:text-black"
        >
          &times;
        </button>

        <div className="flex items-center space-x-4 mt-6">
          <img
            src={userProfilePic}
            alt="Profile"
            className="w-20 h-20 rounded-full object-cover"
          />
          <div>
            <h2 className="text-lg font-semibold text-primaryBlueText capitalize">
              {userFullName}
            </h2>
          </div>
        </div>

        <div className=" flex flex-col mt-5">
          {/* Only visible on screens smaller than md */}
          <div className="md:hidden flex flex-col ">
            {[
              // {
              //   label: "Experiences",
              //   icon: <AwardLink />,
              //   link: "/rsvp/experiences",
              // },
              {
                label: "Communities",
                icon: <CommunityIcon />,
                link: "/rsvp/communities",
              },
            ].map((item, index) => (
              <div
                  key={index}
                  onClick={() => handleNavigation(item)}
                  className="flex py-5 items-center w-full text-left text-darkBlueText bordr-linear cursor-pointer"
                >
                  <span className="mr-3 text-lg">{item.icon}</span>
                  {item.label}
                </div>
            ))}
          </div>

          {/* Other links (visible on all screen sizes) */}
          <div className="flex flex-col">
            {[
              // {
              //   label: "Edit Profile",
              //   icon: <EditProfile />,
              //   link: "/rsvp/edit-profile",
              // },
              {
                label: "My Experiences",
                icon: <MyExperiences />,
                link: "/rsvp/experiences",
              },

              {
                label: "My Badges",
                icon: <Badges />,
                link: "/rsvp/my-badges",
              },

              {
                label: "General Settings",
                icon: <Setting />,
                link: "/rsvp/general-settings",
              },

              {
                label: "Customer Support",
                icon: (
                  // You can replace this with a more appropriate icon if needed.
                  <SecurityUser />
                ),
                link: "#",
              },
              { label: "Logout", icon: <Logout />, link: "/auth/login" },
            ].map((item, index, array) => (
              <div
                key={index}
                onClick={() => handleNavigation(item)}
                className={`flex  items-center w-full text-left text-darkBlueText cursor-pointer ${
                  index === array.length - 1 ? " pt-5" : "bordr-linear py-5"
                }`}
              >
                <span className="mr-3 text-lg">{item.icon}</span>
                {item.label}
              </div>
            ))}
          </div>
        </div>
      </div>
      {showSupportDrawer && (
        <CustomerSupport
          isOpen={showSupportDrawer}
          onClose={() => setShowSupportDrawer(false)}
        />
      )}
    </div>
  );
};

export default RsvpNavbarDrawer;
